import { Component, forwardRef, Input, SimpleChanges } from '@angular/core';
import { AbstractControl, FormControl, ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, Validator, Validators } from '@angular/forms';

import { PageContentService, SessionStorageService } from '../../core/index.service';
import { PageContent } from '../../core/index.model';

@Component({
    selector: 'pnx-number',
    templateUrl: 'number.control.html',
    styleUrls: ['./number.control.css'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => NumberControl), multi: true },
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => NumberControl), multi: true }
    ]
})
export class NumberControl implements ControlValueAccessor, Validator {

    @Input() labelId: string = '';
    @Input() defaultLabel: string = '';
    @Input() placeholderId: string = '';
    @Input() defaultPlaceholder: string = '';

    @Input() pagecontent: PageContent;
    @Input() mandatory: boolean = false;
    @Input() readonly: boolean = false;
    @Input() labelstyle: string = 'control-label';
    @Input() numbercontainerstyle: string = 'col-md-9';
    @Input() numberctrlstyle: string = '';
    @Input() label: string = '';
    @Input() placeholder: string = '';
    @Input('value') _value = '';
    @Input() control: FormControl;
    @Input() disable: boolean = false;
    @Input() maxlength: number = 0;

    disabled: boolean = false;

    constructor(private pageContentService: PageContentService,
        private storageService: SessionStorageService) {

    }

    ngOnInit() {
        if (this.pagecontent) {
            if (!this.pageContentService.pageContent) {
                this.pageContentService.pageContent = this.pagecontent;
            }
        }
    }

    ngOnChanges(Changes: SimpleChanges) {
        if (Changes['disable'] && Changes['disable'].currentValue) {
            this.setDisabledState(true);
        }
        else {
            this.setDisabledState(false);
        }

        if (this.control) {
            this.validate(this.control);
        }

        let labelValue = (this.labelId) ? this.pageContentService.getKeyTxt(this.labelId, this.storageService.getLang()) : this.label;
        let placeHolderValue = (this.placeholderId) ? this.pageContentService.getKeyTxt(this.placeholderId, this.storageService.getLang()) : this.placeholder;

        this.label = (labelValue) ? labelValue : this.defaultLabel;
        this.placeholder = (placeHolderValue) ? placeHolderValue : this.defaultPlaceholder;
    }

    number = new FormControl();

    propagateChange: any = () => { };

    get value() {
        return this._value;
    }

    set value(val) {
        this._value = val;
        this.propagateChange(val);
    }

    onTextChange() {
        this.value = this.number.value;
    }

    setMaxlength(evt: any) {
        
        if (this.maxlength > 0) {
            
            if (this.number.value) {

                let numberValue: string = this.number.value.toString();

                if (numberValue.length > (this.maxlength - 1)) {

                    if (evt.keyCode != 43 && evt.keyCode > 31 && (evt.keyCode < 48 || evt.keyCode > 57 || evt.keyCode < 96 || evt.keyCode > 105)) {
                        if (!this.checkSpecialKeys(evt.keyCode)) {
                            evt.preventDefault();
                        }
                    }
                }
                else {
                    if ((evt.keyCode < 48 || evt.keyCode > 57) && (evt.keyCode < 96 || evt.keyCode > 105)) {

                        if (!this.checkSpecialKeys(evt.keyCode)) {
                            evt.preventDefault();
                        }
                    }
                    else {
                        if (evt.shiftKey) {
                            evt.preventDefault();
                        }
                    }
                }
            }
            else {
                if (evt.keyCode != 9) {

                    if (evt.shiftKey) {
                        evt.preventDefault();
                    }
                    else if ((evt.keyCode < 48 || evt.keyCode > 57) && (evt.keyCode < 96 || evt.keyCode > 105)) {
                        evt.preventDefault();
                    }
                }
            }
        }
    }

    checkSpecialKeys(keyCode: number): boolean {

        if (keyCode === 8 // backspace
            || keyCode === 9 // Tab
            || keyCode === 27 // escape
            || keyCode === 46 // delete
            || keyCode === 16 // shift
            || (keyCode >= 35 && keyCode <= 40)) // end, home, arrows

        {
            return true;
        }
        else {
            return false;
        }
    }

    writeValue(value): void {
        this.value = value;
        this.number.setValue(this.value);
    }

    registerOnChange(fn): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn): void { }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;

        if (this.disabled) {
            this.number.disable();
        }
        else {
            this.number.enable();
        }
    }

    public validate(parentControl: AbstractControl): { [key: string]: any } {

        const val = parentControl.value;

        if (this.mandatory) {

            this.number.setValidators(Validators.required);
            parentControl.setValidators(Validators.required);

            if (!parentControl.value) {
                parentControl.setValue(null);
            }

            if (!val) {
                return { valid: false };
            }
        }
        else {

            this.number.clearValidators();
            parentControl.clearValidators();

            if (!parentControl.value) {
                parentControl.setValue(null);
            }
        }

        return null;
    }
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/controls/number.control.ts